import * as actions from "./actionsTypes";

const initialData = {
  loading: false,
  saveLoader: false,
  campañaLength: 0,
  campaña: [],
  loading2: false,
  saveLoader2: false,
  cuestionarioLength: 0,
  cuestionario: [],
  responsables: [],
  responsablesLoading: false,
  responsablesOtro: [],
  responsablesOtroLoading: false,
  correo: [],
  correoLoading: false,
  survey: [],
  surveyLength: 0,
  surveyLoading: false,
  enlace: "",
  enlaceLoading: false,
  surveyMessage: null,
};

export default function CAMPAÑAReducer(state = initialData, action) {
  switch (action.type) {
    case actions.LOADING_CAMPAÑA:
      return { ...state, loading: action.payload };
    case actions.SAVE_LOADER_CAMPAÑA:
      return { ...state, saveLoader: action.payload };
    case actions.GET_CAMPAÑA:
      return {
        ...state,
        campaña: action.payload.campaña,
        campañaLength: action.payload.campañaLength,
      };
    case actions.LOADING_RESPONSABLE:
      return { ...state, responsablesLoading: action.payload };
    case actions.GET_RESPONSABLE:
      return {
        ...state,
        responsable: action.payload.responsable,
        responsablesLength: action.payload.responsablesLength,
      };
    case actions.LOADING_RESPONSABLE_OTRO:
      return { ...state, responsablesOtroLoading: action.payload };
    case actions.GET_RESPONSABLE_OTRO:
      return {
        ...state,
        responsablesOtro: action.payload.responsablesOtro,
        responsablesOtrosLength: action.payload.responsablesOtrosLength,
      };
    // PARA CORREO
    case actions.LOADING_CORREO:
      return { ...state, correoLoading: action.payload };
    case actions.GET_CORREO:
      return { ...state, correo: action.payload.correo };
    case actions.LOADING_SURVEY_CAMPAÑA:
      return { ...state, surveyLoading: action.payload };
    case actions.GET_SURVEY_CAMPAÑA:
      return {
        ...state,
        survey: action.payload.survey,
        surveyLength: action.payload.surveyLength,
        enlace: action.payload.enlace,
      };
    case actions.LOADING_ENLACE:
      return { ...state, enlaceLoading: action.payload };
    case actions.GET_ENLACE:
      return {
        ...state,
        enlace: action.payload,
      };
    case actions.SEND_SURVEY:
      return {
        ...state,
        surveyMessage: action.payload,
      };
    default:
      return { ...state };
  }
}
